import { forwardRef, type ComponentProps } from 'react';
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button';
import { IconMoreVerticalSmall } from '@amzn/stencil-react-icons';

type OverflowMenuTriggerProps = {
  ariaLabel: string;
} & Omit<ComponentProps<typeof Button>, 'variant' | 'icon' | 'children' | 'aria-label'>;

/**
 * Tertiary button with vertical dots icon for overflow menus.
 * Used as the triggerComponent for Stencil Menu in detail page headers.
 *
 * Menu clones its triggerComponent and injects interaction props
 * (onClick, aria-expanded, ref, ...) — this wrapper MUST forward them
 * to the underlying Button or the menu never opens.
 */
export const OverflowMenuTrigger = forwardRef<
  HTMLButtonElement,
  OverflowMenuTriggerProps
>(function OverflowMenuTrigger({ ariaLabel, ...menuInjectedProps }, ref) {
  return (
    <Button
      {...menuInjectedProps}
      ref={ref}
      variant={ButtonVariant.Tertiary}
      icon={<IconMoreVerticalSmall />}
      aria-label={ariaLabel}
    />
  );
});
